import React, { Component, Fragment } from 'react'
import Hero from '../../Components/Hero'
import Specifications from '../../Components/Specifications'
import Construction from '../../Components/Construction'
import ProsCons from '../../Components/ProsCons'
import Houses from '../../Components/Houses'
import Contact from '../../Components/Contact'
import Footer from '../../Components/Footer'

export default class Home extends Component {
  render() {
    const { content } = this.props

    return (
      <Fragment>
        <Hero data={content.acf.intro} />
        <Specifications data={content.acf.intro} />
        <Construction data={content.acf.constructie} />
        <ProsCons />
        <Houses />
        <Contact />
        <Footer />
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Home/index.js